<template>
  <AuthVisualShell :character-src="characterSrc" character-alt="Personagem Zinnes">
    <main class="login-content auth-flow" aria-labelledby="login-title">
      <section class="auth-step">
        <h1 id="login-title">LOGIN</h1>
        <p class="auth-intro">Bem-vinda(o) de volta! Acesse sua conta para continuar aproveitando nossos serviços.</p>
        <v-form ref="credentialsForm" @submit.prevent="submitCredentials">
          <v-text-field v-model.trim="email" label="E-mail" type="email" autocomplete="email" :rules="emailRules" :disabled="isSubmitting" required />
          <v-text-field
            v-model="password"
            label="Senha"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            :rules="passwordRules"
            :disabled="isSubmitting"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
            required
            @click:append="togglePasswordVisibility"
          />
          <p class="auth-support-link">Esqueceu a senha? <router-link to="/forgot-password">Recuperar</router-link></p>
          <v-btn class="btn-login auth-primary" color="orange" type="submit" :loading="isSubmitting" :disabled="isSubmitting">
            {{ isSubmitting ? 'Entrando...' : 'Entrar' }}
          </v-btn>
        </v-form>
        <div class="auth-feedback" aria-atomic="true">
          <p v-if="errorMessage" id="auth-error" class="auth-error" role="alert">{{ errorMessage }}</p>
          <p v-if="statusMessage" class="auth-status" role="status" aria-live="polite">{{ statusMessage }}</p>
        </div>
        <p class="auth-register-link">Não tem conta? <router-link to="/cadastro">Criar conta</router-link></p>
      </section>
    </main>
  </AuthVisualShell>
</template>

<script>
import AuthVisualShell from '@/components/AuthVisualShell.vue';
import { login } from '@/server/authServe';
import { storeUserData } from '@/utils/storeUserData';
import { emailRules, passwordRules } from '@/utils/validationUtils';
import characterSrc from '@/assets/images/Miry.png';

export default {
  name: 'LoginPage',
  components: { AuthVisualShell },
  data() {
    return {
      email: '', password: '', showPassword: false, errorMessage: '', statusMessage: '', isSubmitting: false,
      emailRules, passwordRules, characterSrc,
    };
  },
  methods: {
    async submitCredentials() {
      if (this.isSubmitting) return;
      if (!this.$refs.credentialsForm.validate()) {
        this.errorMessage = 'Por favor, corrija os erros no formulário.';
        return;
      }
      this.errorMessage = '';
      this.statusMessage = 'Validando seus dados.';
      this.isSubmitting = true;
      try {
        const response = await login(this.email, this.password);
        if (!response?.auth?.access_token || !response?.user) throw new Error('invalid_auth_response');
        storeUserData(response);
        this.password = '';
        this.statusMessage = 'Login realizado. Redirecionando.';
        await this.navigateAfterLogin();
      } catch (error) {
        this.password = '';
        this.statusMessage = '';
        this.errorMessage = error?.message || 'Não foi possível concluir o login. Verifique os dados e tente novamente.';
      } finally {
        this.isSubmitting = false;
      }
    },
    togglePasswordVisibility() { this.showPassword = !this.showPassword; },
    async navigateAfterLogin() {
      const redirect = this.$route.query.redirect;
      const destination = typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//') ? redirect : '/';
      await this.$router.push(destination);
    },
  },
};
</script>

<style scoped>
.auth-flow { width: 100%; }
.auth-feedback { min-height: 32px; }
.auth-error { color: #a51d1d; }
.auth-status { color: #665f55; }
</style>
